import SaleSheetClassificationList from "containers/salesheet/SaleSheetClassificationList";
import { Modal } from "react-bootstrap";

function SaleSheetClassificationModal({
    filter,
    isAuthenticated,
    user,
    classificationOptions,
    data,
    updateTableState,
    saveRecord,
    deleteRecord,
    validateRelatedRecord,
    salesheetid,
    onClose,
    show,
}) {
 
    return (
        <Modal show={show} onHide={onClose} dialogClassName="modal-90w">
            <Modal.Header closeButton>
                <Modal.Title>Sale Sheet Classifications</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SaleSheetClassificationList
                    filter={filter}
                    isAuthenticated={isAuthenticated}
                    isLoading={false}
                    controlType="table"
                    user={user}
                    classificationOptions={classificationOptions}
                    data={data}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                    deleteRecord={deleteRecord}
                    validateRelatedRecord={validateRelatedRecord}
                    salesheetid={salesheetid}
                />
            </Modal.Body>
        </Modal>
    );
}
export default SaleSheetClassificationModal;